<template>
    <div class="spa">


        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>
        <div v-else>
            <div class="row d-flex justify-content-center">
                <div class="col-24 mb-4 d-flex justify-content-center">
                    <h3 class="text-center">Who would like to book the Spa Garden?</h3>
                </div>
            </div>
          
            <div class="row justify-content-center mb-4">
                <div class="col-24 col-xl-12">

                    <info-box v-bind:type="'alert'">

                        <template v-slot:body>
                            <p>All guests must attend the Spa Garden together.</p>

                        </template>
                    </info-box>



                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-24 col-xl-10 bg-white has-shadow p-5 text-start">
                    <h3>Booking</h3>

                    <div class="booking-selection">
                        <label class="mb-2">Names</label>
                   
                        <div v-for="(guest, gi) in guests">
                            <input type="text" class="form-control mb-2" readonly v-bind:value="guest.firstName" />
                        </div>



                        <div v-if="availableTimes == null || !availableTimes.length" class="mb-2">

                            <info-box v-bind:type="'error'">

                                <template v-slot:body>
                                    <p>Sorry, we have no availability.</p>

                                </template>
                            </info-box>
                        </div>

                    </div>


                    <div class="booking-selection" v-if="availableTimes != null && availableTimes.length">
                        <label class="mb-2">Entry Time</label>

                        <select class="form-select mb-2" v-model="selectedTime">
                            <option disabled="disabled" value="">Please select...</option>
                            <option v-for="(item, ai) in availableTimes" v-bind:value="ai">{{formatTime(item.StartDateTime)}}</option>

                        </select>

                    </div>
                </div>

            </div>


            <div class=" g-0 actions">

                <div class="row mt-8 d-flex ">

                    <div class="col-12 d-flex justify-content-start">
                        <button class="btn btn--transparent btn--back" type="button" v-on:click="onClose()">
                            Cancel
                        </button>

                    </div>


                    <div class="col-12 d-flex justify-content-end" v-if="!isLoading">
                        <button class="btn btn--slate-blue btn--continue d-xl-block" v-bind:disabled="!hasCapacity && selectedAvailability != null" type="button" v-on:click="onSubmit()">
                            Done
                        </button>

                    </div>
                </div>
            </div>


        </div>

    </div>

</template>

<script>
    import spaapi from '@/shared/api/spa';

    import { store } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';

    import { _ } from 'vue-underscore';


    export default {
        name: 'SpaAddOngarden',
        props: {
            addOn: Object,
            isDay: Boolean
        },
        components:
        {
            InfoBox,
            Loader
        },
        data() {
            return {
                guests: [],
                isLoading: false,
                selectedTime: '',
                internalAvailaiblity : null
            }
        },
        mounted() {
            let o = this;
            this.isLoading = true;



            let groups = this.search.spaDay.Extras?.filter(item => item.SystemType == "GROUP" && item.ModalType != 'TREATMENTS').flatMap(function (item) {
                return item.Codes.map(function (innerItem) {
                    return innerItem.PremierId;
                })
            });

           
            let extrasPayload = {
                date: moment(this.search.date).format("YYYY-MM-DD"),
        
                groupExtras: groups
            };


            spaapi.getExtras(extrasPayload, t => {
           
                o.internalAvailaiblity = t;


                for (let i = 0; i < this.search.guests.length; i++) {
                    let guest = this.search.guests[i];

                    this.guests.push({
                        guestIndex: i,
                        firstName: guest.firstName,
                        gardenAccess: true
                    })

                }

                o.isLoading = false;


            });

        },
        computed: {
            selectedAvailability() {
                let availableTimes = this.availableTimes;

                if (availableTimes != null) {
                    let selectedItem = availableTimes[+(this.selectedTime)];
                    return selectedItem;
                }
                return null;
            },
            configuration() {
                return store.getters.configuration;
            },
            availableTimes() {
                if (this.hasCapacity) {
                    let result = [];

                    let availabileTime = this.internalAvailaiblity.Groups[0];//.find(item => item.Key == code);

                    let guestMaxArrivalTime = _.max(this.search.guests.map(item => moment.utc(item.spaDayArrivalTime.selectedItem.EndDateTime)));
                    let bandEnd = this.search.spaDay.bookingDetails.TimeBands.find(item => item.BandNumber == this.search.spaDay.Band)?.EndTime;

                    let bandEndTime = moment.utc(bandEnd, "HH:mm")
                    let dayEndTime = moment.utc(this.search.date).add(bandEndTime.hour(), 'h').add(bandEndTime.minutes(), 'm');
             

                    for (let ai = 0; ai < availabileTime.Items.length; ai++) {
                        let a = availabileTime.Items[ai];
                
                        let startTime = moment.utc(a.StartDateTime); // i think we need to remove the duration here..

                        let endTime = moment.utc(a.EndDateTime);

                        //After arrival
                        if (startTime < guestMaxArrivalTime) {
                            continue;
                        }
                       
                        if (endTime > dayEndTime) {
                            continue;
                        }

                        //Not during dining
                        if (this.search?.restaurant != null) {
                            let duration = this.search?.restaurant?.duration ?? 120;
                            let diningAllocation = this.search?.restaurant?.selectedTime?.TimeSlot;
                            if (duration != null && diningAllocation != null) {

                                let minTime = moment.utc(diningAllocation).add(-duration, 'm');
                                let maxTime = moment.utc(diningAllocation).add(duration, 'm');

                                if (startTime.isBetween(minTime, maxTime) || endTime.isBetween(minTime, maxTime)) {
                                    continue;
                                }


                            }
                        }

                        //not during spa garden
                        let canInclude = true;
                        for (var gi = 0; gi < this.search.guests.length; gi++) {
                            let guest = this.search.guests[gi];
                            if (guest.spaArrivalTime != null) {
                                let startGardenTime = moment.utc(guest.spaArrivalTime.StartDateTime);
                                let endGardenTime = moment.utc(guest.spaArrivalTime.EndDateTime);


                                if (startTime.isSame(startGardenTime) ||
                                    startTime.isBetween(startGardenTime, endGardenTime) ||
                                    endTime.isSame(endGardenTime) ||
                                    endTime.isBetween(startGardenTime, endGardenTime)) {
                                    canInclude = false;
                                    break;
                                }
                            }
                        }
                        if (!canInclude) {
                            continue;
                        }
                

                        //flatten treatments
                        let treatmentGuests = this.search.guests.filter(item => item.startTime?.TreatmentTimes != null);
                  
                        if (treatmentGuests != null && treatmentGuests.length) {
                            let flattenedTreatments = this.search.guests.flatMap(function (item) {
                                return item.startTime.TreatmentTimes;
                            });

                            for (var fi = 0; fi < flattenedTreatments.length; fi++) {
                                var fTreatment = flattenedTreatments[fi];

                                let fTreatmentStart = moment.utc(fTreatment.StartTime);
                                let fTreatmentEnd = moment.utc(fTreatment.EndTime);
                          
                                if (startTime.isSame(fTreatmentStart) ||
                                    startTime.isBetween(fTreatmentStart, fTreatmentEnd) ||
                                    endTime.isSame(fTreatmentEnd) ||
                                    endTime.isBetween(fTreatmentStart, fTreatmentEnd)) {
                                    canInclude = false;
                                    break;
                                }

                            }

                            if (!canInclude) {
                                continue;
                            }
                        }

                 
                        let extrasTreatments = this.search.selectedTreatmentExtras;
                        if (extrasTreatments != null && extrasTreatments.length) {
                            let flattenedExtras = extrasTreatments.map(function (item) {
                                return item.time;
                            });


                            for (var fie = 0; fie < flattenedExtras.length; fie++) {
                                var fTreatmentExtra = flattenedExtras[fie];

                                let fExtraTreatmentStart = moment.utc(fTreatmentExtra.TreatmentTimes[0].StartTime);
                                let fExtraTreatmentEnd = moment.utc(fTreatmentExtra.TreatmentTimes[0].EndTime);

                                if (startTime.isSame(fExtraTreatmentStart) ||
                                    startTime.isBetween(fExtraTreatmentStart, fExtraTreatmentEnd) ||
                                    endTime.isSame(fExtraTreatmentEnd) ||
                                    endTime.isBetween(fExtraTreatmentStart, fExtraTreatmentEnd)) {
                                    canInclude = false;
                                    break;
                                }

                            }

                            if (!canInclude) {
                                continue;
                            }
                        }

                        
                        
                        result.push(a);
                    }

                    return result;

                }
                return null
            },
            search() {
                return store.getters.search;
            },
           
            hasCapacity() {
                return this.guests.length >= 2;
            },

        },

        methods: {
            onClose() {
                this.$parent.$emit('close');
            },
            onSubmit() {
               
             
                if (this.selectedAvailability == null) {
                    this.onClose();
                }

                let payload = {
                    guestIndexes: this.guests.map(function (item) { return item.guestIndex; }),
                    code: this.activeCode,
                    selection: this.selectedAvailability,
                    addOn: this.addOn
                }

                store.dispatch('selectGardenExtras', payload).then(() => {
                    this.$parent.$emit('close');

                });

                this.trackAddOnSelection();


            },
         
            formatTime(dateTime) {
                let date = moment(dateTime);
                return date.format("HH:mm");
            },


            trackAddOnSelection() {

                if (this.$gtm.enabled()) {

                    let items = [];
                    for (let i = 0; i < this.addOn.content.Codes.length; i++) {
                        let selected = this.addOn.content.Codes[i];

                        let item = {
                            'item_id': selected.Code,
                            'item_name': this.addOn.content.DisplayName,
                            'price': this.addOn.content.DisplayPrice.replace("£", "")
                        };
                        items.push(item);

                    }

                    window.dataLayer?.push({
                        'pageURL': '/spa/treatment/add-ons',
                        'event': 'add_to_cart',
                        'ecommerce': {
                            'item_list_name': 'Spa Day Add On',
                            'items': items
                        }
                    });
                }

            }

        },
        watch: {
            guests: {
                handler: function (val, oldVal) {
                    this.selectedTime = '';

                },
                deep: true
            }
        },

    }
</script>

<style scoped>
    .garden-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        font-family: 'Montserrat'
    }

        .garden-name input[type=checkbox] {
            width: 30px;
            height: 30px;
            margin-right: 8px;
        }

    .booking-selection label {
        font-size: 14px;
        font-weight: bold;
        font-family: 'Montserrat'
    }

    .booking-selection input[readonly]{
        background:#fff;

    }

</style>